import { render, staticRenderFns } from "./host-project.vue?vue&type=template&id=4a1d64d4&scoped=true&"
import script from "./host-project.vue?vue&type=script&lang=js&"
export * from "./host-project.vue?vue&type=script&lang=js&"
import style0 from "./host-project.vue?vue&type=style&index=0&id=4a1d64d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1d64d4",
  null
  
)

export default component.exports